module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": '/profile/' + _vm.who.id
    }
  }, [_vm._v(_vm._s(_vm._f("name")(_vm.who)))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-751c9e16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-link.vue
// module id = 106
// module chunks = 0 1